var _excluded = ["heading", "subContent", "className", "href", "tag", "imageProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import { rightLinkArrowIcon } from '@lululemon/ecom-pattern-library-icons';
require("./cta-block.css");
var styles = {
  "icon": "icon-wkjLc",
  "ctaBlock": "ctaBlock-9usJ3",
  "fixedHeight": "fixedHeight-3n8uU",
  "content": "content-cMTq7",
  "heading": "heading-3BjmU",
  "subContent": "subContent-FzB_6",
  "imageWrapper": "imageWrapper-2JQMP",
  "image": "image-H5jXj",
  "contentWrapper": "contentWrapper-DdmaE"
};
import LinkGenerator from '../link-generator';
import Icon from '../icons';
import Image from '../image';
var CTABlock = _ref => {
  var {
      heading,
      subContent,
      className,
      href,
      tag,
      imageProps
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag;
  var hasImage = !!(imageProps !== null && imageProps !== void 0 && imageProps.src);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    href: href,
    className: cs(styles.ctaBlock, className, {
      [styles.fixedHeight]: hasImage
    })
  }, otherProps), hasImage && /*#__PURE__*/React.createElement("div", {
    className: styles.imageWrapper
  }, /*#__PURE__*/React.createElement(Image, _extends({
    className: styles.image
  }, imageProps))), /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, !!heading && /*#__PURE__*/React.createElement("span", {
    className: styles.heading
  }, heading), !!subContent && /*#__PURE__*/React.createElement("span", {
    className: styles.subContent
  }, subContent)), /*#__PURE__*/React.createElement(Icon, {
    className: styles.icon,
    content: rightLinkArrowIcon
  })));
};
CTABlock.propTypes = {
  imageProps: PropTypes.shape(_objectSpread(_objectSpread({}, Image.propTypes), {}, {
    src: PropTypes.string
  })),
  heading: PropTypes.node,
  subContent: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType])
};
CTABlock.defaultProps = {
  heading: null,
  subContent: null,
  className: '',
  href: '',
  tag: LinkGenerator,
  imageProps: null
};
export default CTABlock;